module.exports = __webpack_public_path__ + "static/media/Add Circle.cf9d4e5a.svg";